class ProductSelector extends HTMLElement {
  constructor() {
    super();
    this.inputWrapper = "[data-input-wrapper]";
    const LANG = window.localLanguage
    if (LANG == 'en'){
      this.colourLang = 'Color'
    } else {
      this.colourLang = 'Kleur'
    }
    this.variants = JSON.parse(
      this.querySelector('[type="application/json"]').textContent
    );
    this.form = document.querySelector(
      `#ProductForm-${this.dataset.sectionId}`
    );
    this.purchaseOptions = document.querySelector(
      `#Product-Purchase-Options-${this.dataset.sectionId}`
    );
    this.productBar = document.querySelector(
      `#ProductBar-${this.dataset.sectionId}`
    );
    this.installmentsForm = document.querySelector(
      `#Product-Installments-${this.dataset.installmentsFormId}` // check: `${this.dataset.installmentsFormId}`
    );
    this.addEventListener("change", this.onVariantChange);
    this.updateOptions();
    this.updateVariantStatuses();
    this.updateVariant();

    this.form.toggleAddButton(!this.currentVariant.available, "");
    const saleLabel = document.querySelectorAll("[id=form__sale-label]");
    const saleTag = document.querySelectorAll(".badge.sale");

    if (this.currentVariant?.price < this.currentVariant?.compare_at_price) { 
      saleLabel.forEach(element=> {
        element.style.display = "block";
      })
      saleTag.forEach(element=> {
        element.style.display = "block";
      })
    } else {
      saleLabel.forEach(element=> {
        element.style.display = "none";      
      })
      saleTag.forEach(element=> {
        element.style.display = "none";      
      })
    }
  }

  updateVariantStatuses() {
    const inputWrappers = [...this.querySelectorAll(this.inputWrapper)];
  
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
  
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
  
      const filteredVariants = this.variants.filter(
        (variant) =>
          variant.available && variant[`option${index}`] === previousOptionSelected
      );
  
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
  
      const currentColor = inputWrappers[index - 1]
        .querySelector(":checked")
        .getAttribute("value");
  
      const variantsForColor = filteredVariants.filter(
        (variant) => variant.option1 === currentColor
      );
  
      let selectedSize = null;
  
      optionInputs.forEach((input) => {
        const correspondingVariant = variantsForColor.find(
          (variant) => variant[`option${index + 1}`] === input.getAttribute("value")
        );
  
        const inputIsDisabled = !correspondingVariant;
  
        input.disabled = inputIsDisabled;
        if (input.tagName.toLowerCase() === "option") {
          input
            .closest("dropdown-input")
            .querySelector(`button[data-value="${input.value}"]`).disabled =
            inputIsDisabled;
        }
        if (!this.productBar) return;
        const inputId = input.dataset.id || input.id;
        const productBarInput = this.productBar.querySelector(
          `option[data-id="${inputId}"]`
        );
        if (!productBarInput) return;
        productBarInput.disabled = inputIsDisabled;
  
        input.addEventListener("change", () => {
          if (input.checked) {
            selectedSize = input.getAttribute("value");
          }
        });
  
        if (input.checked && !input.disabled) {
          selectedSize = input.getAttribute("value");
        }
      });
  
      if (!selectedSize) {
        for (const variant of variantsForColor) {
          const nextOptionValue = variant[`option${index + 1}`];
          if (nextOptionValue) {
            selectedSize = nextOptionValue;
            break;
          }
        }
      }
      if (selectedSize) {
        const selectedSizeInput = option.querySelector(
          `input[value="${selectedSize}"]`
        );
        if (selectedSizeInput) {
          selectedSizeInput.checked = true;
          if ('createEvent' in document) {
            let evt = document.createEvent('HTMLEvents');
            evt.initEvent('change', false, true);
            selectedSizeInput.dispatchEvent(evt);
          } else {
            selectedSizeInput.fireEvent('onchange');
          }
        }
      }
    });
  }  

  onVariantChange(event) {
    if (event.target.type === "number") return;
    this.updateOptions();
    if (this.currentVariant === this.getVariantData()) return;

    this.productBarUpdateOptions();
    this.updateVariant();
    this.updateVariantStatuses();
    this.updatePickupAvailability();
    this.form.removeAttribute("data-has-selling-plan");
    this.form.toggleAddButton(false, "");
    this.form.handleErrorMessage();

    if (!this.currentVariant) {
      this.form.toggleAddButton(true, "");
      this.setUnavailable();

      return;
    }

    if (!this.currentVariant.available) {
      ``;
      this.form.toggleAddButton(true, window.variantStrings.soldOut);
    }

    this.updateMedia();
    this.updateURL();
    this.updateVariantInput();
    this.renderProductInfo();

    const saleLabel = document.querySelectorAll("[id=form__sale-label]");
    const saleTag = document.querySelectorAll(".badge.sale");

    if (this.currentVariant?.price < this.currentVariant?.compare_at_price) { 
      saleLabel.forEach(element=> {
        element.style.display = "block";
      })
      saleTag.forEach(element=> {
        element.style.display = "block";
      })
    } else {
      saleLabel.forEach(element=> {
        element.style.display = "none";      
      })
      saleTag.forEach(element=> {
        element.style.display = "none";      
      })
    }
  }

  updateOptions() {
    this.querySelectorAll('input[type="radio"]').forEach((input) => {
      input.nextElementSibling.classList.toggle("is-active", input.checked);
    });
    this.options = Array.from(
      this.querySelectorAll('input[type="radio"]:checked, select'),
      (el) => ({ name: el.dataset.name || el.name, value: el.value })
    );
    const colorLabel = document.querySelector(".form__color-label");
    colorLabel.textContent = `${this.colourLang}: ${this.options[0].value}`;

  }

  productBarUpdateOptions() {
    Array.from(this.productBar.querySelectorAll("select")).map((selector) => {
      selector.value = this.options.find(
        (option) => option.name === selector.name
      ).value;
    });
  }

  updatePickupAvailability() {
    const pickUpAvailabilityNode = document.querySelector(
      "pickup-availability"
    );

    if (!pickUpAvailabilityNode || !this.currentVariant) return;

    pickUpAvailabilityNode.dataset.variantId = this.currentVariant.id;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailabilityNode.setAttribute("available", "");
      pickUpAvailabilityNode.fetchAvailability(
        pickUpAvailabilityNode.dataset.variantId
      );

      return;
    }

    pickUpAvailabilityNode.removeAttribute("available");
    pickUpAvailabilityNode.innerHTML = "";
  }

  updateVariant() {
    this.currentVariant = this.getVariantData();
  }

  getVariantData() {
    return this.options.length
      ? this.variants.find((variant) => {
          return !variant.options
            .map((option, index) => this.options[index].value === option)
            .includes(false);
        })
      : this.variants[0];
      
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media) return;

    const productMedia = document.querySelector("product-media");
    productMedia.setActiveMedia(this.currentVariant.featured_media.id);
  }

  updateURL(sellingPlanId) {
    if (!this.currentVariant) return;
    const params = new URLSearchParams(window.location.search);
    params[params.has("variant") ? "set" : "append"](
      "variant",
      this.currentVariant.id
    );
    if (sellingPlanId) {
      params[params.has("selling_plan") ? "set" : "append"](
        "selling_plan",
        sellingPlanId
      );
    } else {
      params.delete("selling_plan");
    }
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?${params.toString()}`
    );
  }

  updateVariantInput() {
    const inputs = [
      this.querySelector('[name="id"'),
      this.installmentsForm?.querySelector('[name="id"]'),
    ];
    inputs.forEach((input) => {
      if (!input) return;
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
    // console.log(this.installmentsForm);
  }

  setUnavailable() {
    const submitButton = this.form.submitButton;
    const price = this.querySelector(
      `#Product-Price-${this.dataset.sectionId}`
    );

    if (!submitButton) return;
    submitButton.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
  }

  renderProductInfo() {
    const params = new URLSearchParams(window.location.search);
    params[params.has("variant") ? "set" : "append"](
      "variant",
      this.currentVariant.id
    );
    params.append("section_id", this.dataset.sectionId);

    fetch(`${this.dataset.url}?${params.toString()}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        [
          `#Product-Price-${this.dataset.sectionId}`,
          `#Product-Purchase-Options-${this.dataset.sectionId}`,
        ].map((liveRegionSelector) => {
          const destination = document.querySelector(liveRegionSelector);
          const source = html.querySelector(liveRegionSelector);

          const inventory = document.getElementById(
            `inventory-display-${this.dataset.sectionId}`
          );

          if (inventory)
            inventory.classList.remove("visibility-hidden"),
              this.updateInventory(html);

          if (destination && source) {
            destination.classList.remove("visibility-hidden");
            destination.innerHTML = source.innerHTML;
          }
        });
      });
  }

  updateInventory(html) {
    const id = `inventory-display-${this.dataset.sectionId}`;
    const destination = document.getElementById(id);
    const source = html.getElementById(id);

    if (source && destination) destination.innerHTML = source.innerHTML;
  }
}

customElements.define("product-selector", ProductSelector);
